import { useTranslation } from 'react-i18next';
import { getIntroImage } from "../api/intro-api"
import { useEffect, useState } from "react";

const Introduction = () => {
    const { t } = useTranslation();
    const [imageSrc, setImageSrc] = useState<string | undefined>(undefined);

    useEffect(() => {
        let objectUrl: string | undefined;
        let isActive = true;

        const fetchImage = async () => {
            try {
                const data = await getIntroImage();
                objectUrl = URL.createObjectURL(data);
                if (isActive) {
                    setImageSrc(objectUrl);
                } else {
                    URL.revokeObjectURL(objectUrl);
                }
            } catch (err: any) {
                
            }
        };

        fetchImage();

        return () => {
            isActive = false;
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, []);

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                <h2 style={{ margin: 0 }}>{t('menu.introduction')}</h2>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
                <img src={imageSrc} alt={t('menu.introduction')} style={{ maxWidth: '100%', maxHeight: '100%' }} />
            </div>
        </>
    );
};

export default Introduction;
